/* eslint-disable import/no-unused-modules */
export class CompanyContact {
  constructor(contactInfo) {
    if (!contactInfo) {
      this.userId = null
      this.email = null
    } else {
      this.userId = contactInfo.userId ? contactInfo.userId : null
      this.email = contactInfo.email ? contactInfo.email : null
    }
  }
  getObject() {
    return JSON.parse(JSON.stringify(this))
  }
}

export class Billing {
  constructor(billingInfo) {
    if (!billingInfo) {
      this.accountNumber = null
      this.sortCode = null
      this.vATRegistered = null
      this.vATNumber = null
      this.payment = null
      this.address = null
      this.contact = null
    } else {
      this.billingTermTypeName = billingInfo.billingTermTypeName
      this.billingTermValue = billingInfo.billingTermValue
      this.sortCode = billingInfo.sortCode ? billingInfo.sortCode : null
      this.address = billingInfo.address ? billingInfo.address : null
      this.contact = billingInfo.contact ? billingInfo.contact : null
      this.payment = billingInfo.payment ? billingInfo.payment : null
      this.vatRegistered = billingInfo.vatRegistered
        ? billingInfo.vatRegistered
        : null
      this.vatNumber = billingInfo.vatNumber ? billingInfo.vatNumber : null
    }
  }
  getObject() {
    return JSON.parse(JSON.stringify(this))
  }
}
export class Client {
  constructor(clientInfo) {
    console.log(clientInfo)
    if (!clientInfo) {
      this.id = null
      this.clientId = null
      this.clientType = null
      this.parentClientId = null
      this.accountNumber = null
      this.accountManager = null
      this.registrationNumber = null
      this.companyName = null
      this.addresses = null
      this.contacts = null
      this.billing = null
      this.status = null
      this.alias = null
      this.applicationTheme = null
      this.applyDestinationLogic = null
      this.automaticAllocation = null
      this.automaticReallocation = null
      this.applyBackupVehicleLogic = null
      this.applyFixedPricing = null
      this.isManaged = null
      this.platformId = null
      this.markup = null
      this.commission = null
    } else {
      this.id = clientInfo.id ? clientInfo.id : null
      this.clientId = clientInfo.id ? clientInfo.id : null
      this.clientType = clientInfo.clientTypeName
        ? clientInfo.clientTypeName
        : null
      this.parentClientId = clientInfo.parentClientId
        ? clientInfo.parentClientId
        : null
      this.accountNumber = clientInfo.accountNumber
        ? clientInfo.accountNumber
        : null
      this.accountManager = clientInfo.accountManager
        ? clientInfo.accountManager
        : null
      this.registrationNumber = clientInfo.registrationNumber
        ? clientInfo.registrationNumber
        : null
      this.platformId = clientInfo.platform.platformId
        ? clientInfo.platform.platformId
        : null
      this.companyName = clientInfo.companyName ? clientInfo.companyName : null
      this.address = clientInfo.address ? clientInfo.address : null
      this.billing = clientInfo.billing ? new Billing(clientInfo.billing) : null
      this.status = clientInfo.status ? clientInfo.status : null
      this.alias = clientInfo.alias ? clientInfo.alias : null
      this.applicationTheme = clientInfo.applicationTheme
        ? clientInfo.applicationTheme
        : null
      this.settings = clientInfo.settings ? clientInfo.settings : null
      this.markup = clientInfo.markup ? clientInfo.markup : null
      this.commission = clientInfo.commission ? clientInfo.commission : null
    }
  }
  getObject() {
    return JSON.parse(JSON.stringify(this))
  }
}
